export enum WatchingPreviewProfileMetricProperties {
  MediaId = 'mediaId',
  ProfileId = 'profileId',
  CurrentPosition = 'currentPosition',
  ViewedSections = 'viewedSections',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  SeriesId = 'seriesId',
}
export enum WatchingPreviewProfileMetricMetaProperties {}
